export const modalStyles = (theme) => ({
  halfView: {
    margin: theme.spacing(0),
    marginTop: theme.spacing(20),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
});
